import type {PermissionsRecordType} from '../permissions';

export const workshopInterestPermissions = {
  workshopInterestRead: {
    actionId: 'READ',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestCreate: {
    actionId: 'CREATE',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestOpen: {
    actionId: 'OPEN',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestEnd: {
    actionId: 'END',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestClose: {
    actionId: 'CLOSE',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestReopen: {
    actionId: 'REOPEN',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestScheduleVisit: {
    actionId: 'SCHEDULE_VISIT',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestDelete: {
    actionId: 'DELETE',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestSetNote: {
    actionId: 'SET_NOTE',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestSetSource: {
    actionId: 'SET_SOURCE',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestChangeUtm: {
    actionId: 'CHANGE_UTM',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestChangeBranch: {
    actionId: 'CHANGE_BRANCH',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestChangeCustomer: {
    actionId: 'CHANGE_CUSTOMER',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestSelectContactPerson: {
    actionId: 'SELECT_CONTACT_PERSON',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestChangeLeadQuality: {
    actionId: 'CHANGE_LEAD_QUALITY',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestCustomFields: {
    actionId: 'CUSTOM_FIELDS_PAYLOAD_UPDATE',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['BRANCH', 'PARTICIPATION'],
  },
  workshopInterestCommentRead: {
    actionId: 'COMMENT_READ',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestCommentAdd: {
    actionId: 'COMMENT_ADD',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestCommentUpdate: {
    actionId: 'COMMENT_UPDATE',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestCommentDelete: {
    actionId: 'COMMENT_DELETE',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestUpdateCustomerRequest: {
    actionId: 'UPDATE_CUSTOMER_REQUEST',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestAddCustomerRequest: {
    actionId: 'ADD_CUSTOMER_REQUEST',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestRemoveCustomerRequest: {
    actionId: 'REMOVE_CUSTOMER_REQUEST',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestSelectVehicle: {
    actionId: 'SELECT_VEHICLE',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestRemoveVehicle: {
    actionId: 'REMOVE_VEHICLE',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestUpdateVehicleDetails: {
    actionId: 'UPDATE_VEHICLE_DETAILS',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestUpdateVehicleInformation: {
    actionId: 'UPDATE_VEHICLE_INFORMATION',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestTagReadRecord: {
    actionId: 'RECORD_TAG_VALUES_READ_RECORD_TAG_VALUES',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestTagAddToRecord: {
    actionId: 'RECORD_TAG_VALUES_ADD_TAG_VALUE_TO_RECORD',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestTagRemoveFromRecord: {
    actionId: 'RECORD_TAG_VALUES_REMOVE_TAG_VALUE_FROM_RECORD',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestAssignUser: {
    actionId: 'PARTICIPATION_ASSIGN_USER_COMMAND',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestAssignOrganizationalUnit: {
    actionId: 'PARTICIPATION_ASSIGN_ORGANIZATIONAL_UNIT_COMMAND',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestUnassignUser: {
    actionId: 'PARTICIPATION_UNASSIGN_USER_COMMAND',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestUnassignOrganizationalUnit: {
    actionId: 'PARTICIPATION_UNASSIGN_ORGANIZATIONAL_UNIT_COMMAND',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestTransferOwnershipToUser: {
    actionId: 'PARTICIPATION_TRANSFER_OWNERSHIP_TO_USER_COMMAND',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestTransferOwnershipToOrganizationalUnit: {
    actionId: 'PARTICIPATION_TRANSFER_OWNERSHIP_TO_ORGANIZATIONAL_UNIT_COMMAND',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestTransferOwnershipToTeamUser: {
    actionId: 'PARTICIPATION_TRANSFER_OWNERSHIP_TO_TEAM_USER_COMMAND',
    resourceId: 'WORKSHOP_INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  workshopInterestTagCreate: {
    actionId: 'CREATE',
    resourceId: 'WORKSHOP_INTEREST_TAG',
    scopes: [],
  },
  workshopInterestTagAdd: {
    actionId: 'ADD_TAG_VALUE',
    resourceId: 'WORKSHOP_INTEREST_TAG',
    scopes: [],
  },
  workshopInterestTagUpdate: {
    actionId: 'UPDATE_TAG_VALUE',
    resourceId: 'WORKSHOP_INTEREST_TAG',
    scopes: [],
  },
  workshopInterestTagRemove: {
    actionId: 'REMOVE_TAG_VALUE',
    resourceId: 'WORKSHOP_INTEREST_TAG',
    scopes: [],
  },
  workshopInterestCustomFieldRead: {
    actionId: 'READ',
    resourceId: 'WORKSHOP_INTEREST_CUSTOM_FIELD',
    scopes: [],
  },
} satisfies PermissionsRecordType;
